import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './correction.reducer';

export const CorrectionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const correctionEntity = useAppSelector(state => state.correction.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="correctionDetailsHeading">
          <Translate contentKey="tycheApp.correction.detail.title">Correction</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tycheApp.correction.id">Id</Translate>
            </span>
          </dt>
          <dd>{correctionEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tycheApp.correction.status">Status</Translate>
            </span>
          </dt>
          <dd>{correctionEntity.status}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="tycheApp.correction.createdAt">Request Date</Translate>
            </span>
          </dt>
          <dd>
            {correctionEntity.createdAt ? <TextFormat value={correctionEntity.createdAt} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="errorType">
              <Translate contentKey="tycheApp.correction.errorType">Error Type</Translate>
            </span>
          </dt>
          <dd>{correctionEntity.errorType}</dd>
          <dt>
            <span id="assignee">
              <Translate contentKey="tycheApp.correction.assignee">Assignee</Translate>
            </span>
          </dt>
          <dd>{correctionEntity.assignee}</dd>
          <dt>
            <span id="correctedDeal">
              <Translate contentKey="tycheApp.correction.correctedDeal">Corrected Deal</Translate>
            </span>
          </dt>
          <dd>{correctionEntity.correctedDeal}</dd>
          <dt>
            <span id="remark">
              <Translate contentKey="tycheApp.correction.remark">Remark</Translate>
            </span>
          </dt>
          <dd>{correctionEntity.remark}</dd>
          <dt>
            <Translate contentKey="tycheApp.correction.userCashBack">User Cash Back</Translate>
          </dt>
          <dd>{correctionEntity.userCashBack ? correctionEntity.userCashBack.id : ''}</dd>
          <dt>
            <Translate contentKey="tycheApp.correction.customer">Customer</Translate>
          </dt>
          <dd>{correctionEntity.customer ? correctionEntity.customer.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/correction" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/correction/${correctionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CorrectionDetail;
